import { SalonInfos } from "../../components/signupPage/SignupPage";
import { sendContactPartner } from "../../api/signup";

function signup(salonInfos: SalonInfos) {
  return sendContactPartner(salonInfos);
}

export { signup };
